// extracted by mini-css-extract-plugin
export default {"wrapper":"Preloader_wrapper__dgQWE","pulse":"Preloader_pulse__wMRru","pulser":"Preloader_pulser__yXHk3"};